export default {
  title: 'Create message'
}
